import * as React from "react";
import { forwardRef } from "react";
const SvgDone = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 11, viewBox: "0 0 14 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.75 8.51746L12.6953 0.536987L13.75 1.59167L4.75 10.5917L0.566406 6.40808L1.58594 5.35339L4.75 8.51746Z", fill: "#039BE5" }));
const ForwardRef = forwardRef(SvgDone);
export { ForwardRef as ReactComponent };
